import { render, staticRenderFns } from "./EventTicketTransfer.vue?vue&type=template&id=51183e2d&"
import script from "./EventTicketTransfer.vue?vue&type=script&lang=js&"
export * from "./EventTicketTransfer.vue?vue&type=script&lang=js&"
import style0 from "./EventTicketTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VFlex,
  VForm,
  VLayout,
  VTextField,
})
